import { observable, action } from 'mobx';

export default class LogStore {
  @observable logs = [];

  // 步长基数 例如 每隔500ms取一次值 步长基数为 500/1000 0.5
  @observable step = 0.5

  // 日志通讯次数
  @observable count = 0;

  // 蓝牙基值存储 提供给动态折线图使用
  @observable xyzt = {
    xAxisData: [0],
    xData: [0],
    yData: [0],
    zData: [0]
  }

  @action setXYZ(data) {
    console.log(`初始值：${data}`);
    const temp = data.match(/\((.*)?\)/)[1];
    const result = temp.replace(/(\[|\])/g, '').split(', ');
    const x = result[result.length - 3];
    const y = result[result.length - 2];
    const z = result[result.length - 1];
    this.count++;

    this.xyzt.xAxisData.push(`${this.count * this.step * 10 / 10}s`);
    this.xyzt.xData.push(x);
    this.xyzt.yData.push(y);
    this.xyzt.zData.push(z);
  }

  @action resetXYZ() {
    this.xyzt = {
      xAxisData: [0],
      xData: [0],
      yData: [0],
      zData: [0]
    };
    this.step = 0.5;
    this.count = 0;
  }

  // 蓝牙打开失败或者成功的消息
  @action setLog(data) {
    this.logs.push(data);
  }

  @action reset() {
    this.logs = [];
  }
}

export const logStore = new LogStore();
